import globalAxios from 'axios';
import { createRequestFunction, DUMMY_BASE_URL, setSearchParams, toPathString } from '../common.mjs';
import { BASE_PATH } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const WorkspaceUserControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 구성원에게 매핑된 Workspace 유저 목록을 조회합니다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyWorkspaceUsers: (options = {}) => {
      const localVarPath = `/api/v2/workspace/users/me/workspace-users`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getMyWorkspaceUsers",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const WorkspaceUserControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = WorkspaceUserControllerApiAxiosParamCreator();
  return {
    /**
     * 
     * @summary 구성원에게 매핑된 Workspace 유저 목록을 조회합니다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyWorkspaceUsers(options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getMyWorkspaceUsers(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const getMyWorkspaceUsersRemote = makeRemoteWithOpenapiGenerator({
  requestArgs: WorkspaceUserControllerApiAxiosParamCreator().getMyWorkspaceUsers(),
  requestFn: WorkspaceUserControllerApiFp().getMyWorkspaceUsers
});

export { WorkspaceUserControllerApiAxiosParamCreator, WorkspaceUserControllerApiFp, getMyWorkspaceUsersRemote };
//# sourceMappingURL=workspace-user-controller-api.mjs.map
